import React, { useEffect, useState } from "react";
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import EditableTable from "./AgencyTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import api from "../../../auth/api";
import { alertSuccess, alertError } from "../../../components/Alert";
import AddAgency from "./AddAgency";
import { fetchCountryList } from "@/slices/LocationSlice/countrySlice";
import { useSelector, useDispatch } from "react-redux";

export default function Giveaway() {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [changeLogData, setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const itemsPerPage = 10;
  const editableFields = ['agencyName', 'Category', 'SubCategory', 'agencyDetail', 'Collaboration_at', 'status', 'country'];
  const [addDis, setAddDis] = useState(false);

  const [agencyCategoryList, setAgencyCategoryList] = useState([]);
  const [agencySubCategoryList, setAgencySubCategoryList] = useState([]);
  const { countryList, status } = useSelector((state) => state.countryList);

  useEffect(() => {
    fetchData();
    getAgencyCategoryList();
    getAgencySubCategoryList();
  }, []);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchCountryList());
    }
  }, [dispatch, status]);

  const getAgencyCategoryList = async () => {
    try {
      const response = await api.get("/redeem/panel/Category");
      setAgencyCategoryList(response.data.result);
      // console.log(response.data.result)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getAgencySubCategoryList = async () => {
    try {
      const response = await api.get("/redeem/panel/SubCategory");
      setAgencySubCategoryList(response.data.result);
      // console.log(response.data.result)

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await api.get("/redeem/panel/agency");
      setData(response.data.result);
      setChangeLogData(response.data.Change_Log)
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = data.find((item) => item.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    try {
      const categoryId = agencyCategoryList.filter(f => f.title === editedData.Category)[0].id;
      const subCategoryId = agencySubCategoryList.filter(f => f.title === editedData.SubCategory)[0].id;
      const countryId = countryList?.result?.filter(f => f.title === editedData.country)[0]?.id;
      const finalData = {
        id: editedData.id,
        agencyName: editedData.agencyName,
        agencyDetail: editedData.agencyDetail,
        title: editedData.title,
        Collaboration_at: editedData.Collaboration_at,
        Category: categoryId,
        SubCategory: subCategoryId,
        status: editedData.status,
        country: countryId
      }
      console.log(finalData)
      await api.patch(`/redeem/panel/agency`, finalData);
      alertSuccess("Data updated successfully");
      setEditRowId(null);
      fetchData();
    } catch (error) {
      alertError(error?.response?.data?.errors)
      console.error("Error updating data:", error);
    }

  };

  const handleAdd = async () => {
    setAddDis(true)
  };

  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]
      ?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true)
  };



  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional" || field === "status") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };


  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];

  const handleUploadImage = (row) => {
    console.log(row.id);
    alert(row.id)
  }




  if (loading) return <Loader />;

  return (
    <div className="w-full flex items-center flex-col">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        handleUploadImage={handleUploadImage}
        fetchData={fetchData}
        agencyCategoryList={agencyCategoryList}
        agencySubCategoryList={agencySubCategoryList}
        countryList={countryList?.result}
      />
      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
        <button className="activeBtn text-sm text-white py-1 px-2 rounded" onClick={handleAdd}>
          + Add Agency
        </button>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />


      <Modal isOpen={addDis} onClose={() => setAddDis(false)} title="Add Agency" content={<AddAgency onSuccess={fetchData} agencyCategoryList={agencyCategoryList} agencySubCategoryList={agencySubCategoryList} />} />

    </div>
  );
}
